module.exports = __webpack_public_path__ + "images/active-highlight.1f8436a854140a4dd857335f88852077.png";